import React, { useEffect, useState } from "react";
import MobileLayout from "../components/layout/MobileLayout";
import { api } from "../lib/api";
import { Bell } from "lucide-react";

export default function Notifications() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/notifications").then(({data}) => setItems(data)); }, []);
  return (
    <MobileLayout>
      <h1 className="font-display font-bold text-2xl tracking-tight text-gold-static mb-3">Notifications</h1>
      {items.length === 0 ? (
        <div className="text-center py-16 text-cyan-200/60">
          <Bell className="w-10 h-10 mx-auto mb-2 opacity-60 text-cyan-300" />
          <div className="text-sm">No notifications yet</div>
        </div>
      ) : (
        <div className="space-y-2" data-testid="notifications-list">
          {items.map(n => (
            <div
              key={n.id}
              className="rounded-xl p-3 backdrop-blur-sm shadow-lg"
              style={{
                background: "linear-gradient(180deg, rgba(10,24,51,0.65) 0%, rgba(6,14,40,0.9) 100%)",
                border: "1px solid rgba(34,211,238,0.25)",
              }}
              data-testid={`notification-${n.id}`}
            >
              <div className="font-display font-semibold text-white text-sm">{n.title}</div>
              <div className="text-xs text-cyan-100/80 mt-1">{n.body}</div>
              <div className="text-[10px] text-cyan-200/60 mt-1">{new Date(n.created_at).toLocaleString()}</div>
            </div>
          ))}
        </div>
      )}
    </MobileLayout>
  );
}
